/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Processing_OrderInputs */

const en_processing_order = /** @type {(inputs: Processing_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing Order`)
};

const es_processing_order = /** @type {(inputs: Processing_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando Pedido`)
};

const fr_processing_order = /** @type {(inputs: Processing_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement de la commande`)
};

const de_processing_order = /** @type {(inputs: Processing_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellung wird bearbeitet`)
};

const id_processing_order = /** @type {(inputs: Processing_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memproses Pesanan`)
};

/** @type {(inputs: Processing_OrderInputs) => LocalizedString} */
const ja_processing_order = en_processing_order;

/** @type {(inputs: Processing_OrderInputs) => LocalizedString} */
const zh_processing_order = en_processing_order;

/** @type {(inputs: Processing_OrderInputs) => LocalizedString} */
const ar_processing_order = en_processing_order;

/** @type {(inputs: Processing_OrderInputs) => LocalizedString} */
const it_processing_order = en_processing_order;

/** @type {(inputs: Processing_OrderInputs) => LocalizedString} */
const ru_processing_order = en_processing_order;

/** @type {(inputs: Processing_OrderInputs) => LocalizedString} */
const pt_processing_order = en_processing_order;

/** @type {(inputs: Processing_OrderInputs) => LocalizedString} */
const ko_processing_order = en_processing_order;

/**
* | output |
* | --- |
* | "Processing Order" |
*
* @param {Processing_OrderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const processing_order = /** @type {((inputs?: Processing_OrderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Processing_OrderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_processing_order(inputs)
	if (locale === "es") return es_processing_order(inputs)
	if (locale === "fr") return fr_processing_order(inputs)
	if (locale === "de") return de_processing_order(inputs)
	if (locale === "ja") return ja_processing_order(inputs)
	if (locale === "zh") return zh_processing_order(inputs)
	if (locale === "ar") return ar_processing_order(inputs)
	if (locale === "id") return id_processing_order(inputs)
	if (locale === "it") return it_processing_order(inputs)
	if (locale === "ru") return ru_processing_order(inputs)
	if (locale === "pt") return pt_processing_order(inputs)
	return ko_processing_order(inputs)
});